import React, { useEffect, useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotifications } from './NotificationContext';
import { useNavigate } from 'react-router-dom';


interface NotificationBellProps {
  className?: string;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ className }) => {
  const { totalUnreadNotifications, refreshNotifications } = useNotifications();
  const navigate = useNavigate();
  const [bellInitialized, setBellInitialized] = useState(false);



  // Only fetch notifications once on initial mount
  useEffect(() => {
    if (!bellInitialized) {
      // Use a specific endpoint or parameters for the bell that won't interfere
      // with the main notification page filters
      refreshNotifications(0, 1, false, null);
      setBellInitialized(true);
    }
  }, [refreshNotifications, bellInitialized]);

  const handleClick = () => {
    navigate('/notifications');
  };

  return (
    <Tooltip title="Powiadomienia">
      <IconButton
        color="inherit"
        onClick={handleClick}
        sx={{ ml: 1 }}
        className={className}
      >
        <Badge badgeContent={totalUnreadNotifications} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationBell;